export default __webpack_public_path__ + "static/media/t15.min.d0a48098.png";